import React from 'react';
import {Input, InputNumber, Modal, Table} from 'antd';
import IconTip from '../../components/IconTip';
import './MeetingDevice.less';
import {FormattedMessage, injectIntl} from 'react-intl';

class MeetingDevice extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      allDevice: [],
      searchName: '',
      selectedDeviceTemp: [],
      selectedDevice: []
    };
  }

  componentWillMount() {
    const {dispatch} = this.props;
    const promise = new Promise((resolve, reject) => {
      dispatch({type: 'meetingInfo/getDevice', resolve, reject});
    });
    promise.then(
      () => {
        let {allDeviceIncludeDel, meetingDevice} = this.props;
        let selectedDevice = [];
        let selectedDeviceTemp = [];
        allDeviceIncludeDel.map(item => {
          item.selNum = 1;
          meetingDevice.map(md => {
            if (md.device.id == item.id) {
              item.selNum = md.number;
              selectedDevice.push(item);
              selectedDeviceTemp.push(item);
            }
          });
        });
        //此处allDevice中包括了已经逻辑删除的 为了回显
        this.setState({
          allDevice: allDeviceIncludeDel,
          selectedDevice,
          selectedDeviceTemp
        });
      },
      msg => {
        console.log('获取所有移动设备出错', msg);
      }
    );
  }

  render() {
    const {dispatch, meeting, intl} = this.props;
    const {searchName, selectedDevice, selectedDeviceTemp} = this.state;
    // const allDevice = this.state.allDevice;

    const allDeviceForMeeting = this.props.allDeviceForMeeting.filter(
      device => {
        if (searchName === '') {
          return true;
        } else {
          return device.name.indexOf(searchName) != -1;
        }
      }
    );
    const columns = [
      {
        title: intl.formatMessage({id: "meeting_device_type"}),
        dataIndex: 'name',
        width: this.props.viewOnly ? '33%' : '25%'
      },
      {
        title: intl.formatMessage({id: "device_manage_device_describe"}),
        key: 'remark',
        width: this.props.viewOnly ? '33%' : '25%',
        render: record => {
          return <span>{record.remark || '暂无'}</span>;
        }
      },
      {
        title: intl.formatMessage({id: "device_manage_number"}),
        key: 'num',
        width: this.props.viewOnly ? '33%' : '25%',
        render: record => {
          if (this.props.viewOnly) {
            return <span>{record.selNum}</span>;
          }
          return (
            <div className="num_sel">
              <InputNumber
                value={record.selNum || 0}
                min={1}
                precision={0}
                max={record.number}
                keyDown={e => {
                }}
                onChange={value => {
                  if (isNaN(value)) {
                    value = 0;
                  }
                  let newSelectedDevice = selectedDevice;
                  newSelectedDevice.map(sd => {
                    if (sd.id == record.id) {
                      sd.selNum = value;
                    }
                  });
                  this.setState({selectedDevice: newSelectedDevice});
                }}
              />
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({id: "meeting_list_table_operate"}),
        key: 'do',
        width: this.props.viewOnly ? '33%' : '25%',
        render: record => {
          return (
            <span
              className="main_color_btn"
              onClick={() => {
                let newSelectedDevice = this.state.selectedDevice.filter(sd => {
                  return sd.id != record.id;
                });
                this.setState({
                  selectedDevice: newSelectedDevice,
                  selectedDeviceTemp: newSelectedDevice
                });
              }}
            >
              <IconTip title="删除" type="shanchu"/>
            </span>
          );
        }
      }
    ];

    if (this.props.viewOnly) {
      columns.length = columns.length - 1;
    }

    const data = selectedDevice;

    const columnForModal = [
      {
        title: intl.formatMessage({id: "group_name2"}),
        dataIndex: 'name',
        width: '25%'
      },
      {
        title: intl.formatMessage({id: "port_manage_describe"}),
        dataIndex: 'remark',
        width: '75%',
        render: remark => {
          return <span>{remark || intl.formatMessage({id: "support_manage_front_empty"})}</span>;
        }
      }
    ];

    let selectedRowKeys = [];
    selectedDeviceTemp.map(sdt => {
      selectedRowKeys.push(sdt.id);
    });
    const rowSelectionForModal = {
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        selectedRows.map(sd => {
          if (!selectedDevice.some(item => item.id == sd.id)) {
            sd.selNum = 1;
          }
        });
        this.setState({
          selectedDeviceTemp: this.state.selectedDevice.concat(selectedRows)
        });
      },
      getCheckboxProps: record => ({
        disabled:
          this.state.selectedDevice.some(sd => sd.id == record.id) ||
          record.number == 0, // Column configuration not to be checked
        name: record.name
      })
    };

    return (
      <div className="meeting_device">
        <Modal
          visible={this.state.showModal}
          destroyOnClose={true}
          footer={null}
          wrapClassName="modal-close-header"
          title={intl.formatMessage({id: 'meeting_device_add'})}
          onCancel={() => {
            this.setState({showModal: false});
          }}
          key={`meeting_device_table`}
        >
          <div className="device_modal_table">
            <div className="meeting_modal_content">
              <Input.Search
                placeholder={intl.formatMessage({id: 'meeting_device_search'})}
                onSearch={value => {
                  this.setState({searchName: value});
                }}
                style={{marginBottom: '20px', marginTop: '20px'}}
              />
              <Table
                rowKey={record => record.id}
                dataSource={allDeviceForMeeting}
                columns={columnForModal}
                rowSelection={rowSelectionForModal}
                pagination={
                  allDeviceForMeeting.length > 5 ? {pageSize: 5} : false
                }
              />
            </div>
            <div className="meeting_modal_footer">
              <div
                className="device_button_cancel"
                onClick={() => {
                  this.setState({showModal: false});
                }}
              >
                <FormattedMessage id="dialog_btn_cancel"/>
              </div>
              <div
                className="device_button_ok"
                onClick={() => {
                  let newSelectedDevice = [];
                  this.state.selectedDeviceTemp.map(item => {
                    if (!newSelectedDevice.some(sd => sd.id == item.id)) {
                      newSelectedDevice.push(item);
                    }
                  });
                  this.setState({
                    showModal: false,
                    selectedDevice: newSelectedDevice
                  });
                }}
              >
                <FormattedMessage id="dialog_btn_ok"/>
              </div>
            </div>
          </div>
        </Modal>
        <div className="device_table">
          {this.props.viewOnly ? null : (
            <div className="button_div">
              <div
                className="button_add"
                onClick={() => {
                  this.setState({showModal: true, searchName: ''});
                }}
              >
                {' '}
                + <FormattedMessage id="add"/>
              </div>

              <div className="button_save">
                <div
                  className="meeting_button"
                  onClick={() => {
                    const _this = this;
                    if (meeting && meeting.type != 0) {
                      Modal.confirm({
                        content: '是否将该移动设备借用同步到其余未开始的会议?',
                        okText: '是',
                        onOk: function () {
                          dispatch({
                            type: 'meetingInfo/saveMeetingDevice',
                            payload: {
                              meetingDevices: _this.state.selectedDevice,
                              type: 1
                            }
                          });
                        },
                        cancelText: '否',
                        onCancel: function () {
                          dispatch({
                            type: 'meetingInfo/saveMeetingDevice',
                            payload: {
                              meetingDevices: _this.state.selectedDevice,
                              type: 0
                            }
                          });
                        }
                      });
                    } else {
                      dispatch({
                        type: 'meetingInfo/saveMeetingDevice',
                        payload: {
                          meetingDevices: _this.state.selectedDevice,
                          type: 0
                        }
                      });
                    }
                  }}
                >
                  <FormattedMessage id="btn_save"/>
                </div>
              </div>
            </div>
          )}
          <Table
            className={'meeting_device_table_wrap'}
            rowKey={record => record.id}
            dataSource={data}
            columns={columns}
            pagination={false}
          />
        </div>
      </div>
    );
  }
}

export default injectIntl(MeetingDevice);



// WEBPACK FOOTER //
// ./src/components/meetingList/MeetingDevice.js